import * as schemaAvailabilityRecords from "~/schemas/schema.availability_records.jsx";
import * as schemaCalendarEvents from "~/schemas/schema.calendarEvents";
import * as schemaProjects from "~/schemas/schema.projects.jsx";
import * as schemaSubtasks from "~/schemas/schema.subtasks";
import * as schemaTasks from "~/schemas/schema.tasks.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import { param } from "~/utils/url_helper.jsx";

export const fetchWorkloadTasks = (workloadRange) => {
  return {
    types: [
      actionTypes.FETCH_WORKLOAD_TASKS_LOADING,
      actionTypes.FETCH_WORKLOAD_TASKS_SUCCESS,
      actionTypes.FETCH_WORKLOAD_TASKS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/workload/tasks?${param(workloadRange)}`,
      }),
    payload: {
      schema: schemaTasks.arrayOfTasks,
    },
  };
};

export const fetchGhostTasks = (workloadRange) => {
  return {
    types: [
      actionTypes.FETCH_GHOST_TASKS_LOADING,
      actionTypes.FETCH_GHOST_TASKS_SUCCESS,
      actionTypes.FETCH_GHOST_TASKS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/calendar-events?from=${workloadRange.start_date}
        &to=${workloadRange.end_date}
        &filter=everything_in_all_projects_for_ghost_tasks`,
      }),
  };
};

export const fetchWorkloadProjects = () => {
  return {
    types: [
      actionTypes.FETCH_WORKLOAD_PROJECTS_LOADING,
      actionTypes.FETCH_WORKLOAD_PROJECTS_SUCCESS,
      actionTypes.FETCH_WORKLOAD_PROJECTS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/workload/projects`,
      }),
    payload: {
      schema: schemaProjects.arrayOfProjects,
    },
  };
};

export const toggleCompletedTasks = (userId, toggle) => {
  return {
    type: actionTypes.WORKLOAD_TOGGLE_COMPLETED_TASKS,
    userId,
    toggle,
  };
};

export const getWorkloadAvailabilityRecords = (workloadRange) => {
  return {
    types: [
      actionTypes.FETCH_AVAILABILITY_RECORDS_LOADING,
      actionTypes.FETCH_AVAILABILITY_RECORDS_SUCCESS,
      actionTypes.FETCH_AVAILABILITY_RECORDS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/availability-records/all?${param(workloadRange)}`,
      }),
    payload: {
      schema: schemaAvailabilityRecords.arrayOfAvailabilityRecords,
    },
  };
};

export const fetchWorkloadSubtasks = (workloadRange) => {
  return {
    types: [
      actionTypes.FETCH_WORKLOAD_SUBTASKS_LOADING,
      actionTypes.FETCH_WORKLOAD_SUBTASKS_SUCCESS,
      actionTypes.FETCH_WORKLOAD_SUBTASKS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/workload/subtasks?${param(workloadRange)}`,
      }),
    payload: {
      schema: schemaSubtasks.arrayOfSubtasks,
    },
  };
};

export const fetchWorkloadCalendarEvents = (workloadRange) => {
  return {
    types: [
      actionTypes.FETCH_WORKLOAD_CALENDAR_EVENTS_LOADING,
      actionTypes.FETCH_WORKLOAD_CALENDAR_EVENTS_SUCCESS,
      actionTypes.FETCH_WORKLOAD_CALENDAR_EVENTS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/workload/events?${param(workloadRange)}`,
      }),
    payload: {
      schema: schemaCalendarEvents.arrayOfCalendarEvents,
    },
  };
};
